document.addEventListener('DOMContentLoaded', function () {
  // Helper to safely set inner text
  function setLabelText(id, text) {
    const el = document.getElementById(id);
    if (el) el.innerText = text;
  }

  // Helper to update URL filter parameter without reloading
  function updateURLFilterParam(filterHandle) {
    const url = new URL(window.location);
    if (filterHandle) {
      url.searchParams.set('filter', filterHandle);
    } else {
      url.searchParams.delete('filter');
    }
    window.history.replaceState({}, '', url);
  }

  // Detect if we are in custom-filter mode (blocks override dynamic type tabs)
  const typeFiltersEl = document.querySelector('.cac-type-filters');
  const isCustomFilterMode = typeFiltersEl && typeFiltersEl.getAttribute('data-filter-mode') === 'true';

  // State
  let state = {
    type: null,         // used in dynamic-type mode
    customFilter: null, // used in custom-filter mode (stores block id)
    sort: 'relevance',
    tag1: [],
    tag2: 'tutte le fasi'
  };

  const grid = document.getElementById('cac-product-grid');
  const countSpan = document.getElementById('cac-count');
  const typeTabs = document.querySelectorAll('.cac-type-tab');
  const typeFilters = document.querySelector('.cac-type-filters');
  const dropdowns = document.querySelectorAll('.cac-dropdown');
  const clearBtn = document.getElementById('cac-clear-filters');
  const defaultLabels = {
    tag1: document.getElementById('tag1-label') ? document.getElementById('tag1-label').innerText : '',
    tag2: document.getElementById('tag2-label') ? document.getElementById('tag2-label').innerText : ''
  };

  // 1. Type / Custom Filter Tabs Click
  const mobileChevrons = document.querySelectorAll('.cac-mobile-chevron');
  mobileChevrons.forEach(chevron => {
    chevron.addEventListener('click', function(e) {
      if (window.innerWidth <= 992) {
        e.stopPropagation();
        const tab = this.closest('.cac-type-tab');
        if (tab) {
          tab.classList.toggle('mobile-expanded');
        }
      }
    });
  });

  typeTabs.forEach(tab => {
    tab.addEventListener('click', function () {

      if (isCustomFilterMode) {
        // --- Custom Filter Mode ---
        const cfId = this.getAttribute('data-custom-filter-id');
        if (state.customFilter === cfId) {
          state.customFilter = null;
          this.classList.remove('active-type');
          if (typeFilters) typeFilters.classList.remove('has-active-tab');
          updateURLFilterParam(null);
        } else {
          typeTabs.forEach(t => t.classList.remove('active-type'));
          state.customFilter = cfId;
          this.classList.add('active-type');
          if (typeFilters) typeFilters.classList.add('has-active-tab');
          updateURLFilterParam(this.getAttribute('data-handle'));
        }
      } else {
        // --- Dynamic Product-Type Mode ---
        const type = this.getAttribute('data-type');
        if (state.type === type) {
          state.type = null;
          this.classList.remove('active-type');
          if (typeFilters) typeFilters.classList.remove('has-active-tab');
          updateURLFilterParam(null);
        } else {
          typeTabs.forEach(t => t.classList.remove('active-type'));
          state.type = type;
          this.classList.add('active-type');
          if (typeFilters) typeFilters.classList.add('has-active-tab');
          updateURLFilterParam(this.getAttribute('data-handle'));
        }
      }

      applyFilters();
    });
  });

  // 2. Dropdown Logic
  dropdowns.forEach(dropdown => {
    const selected = dropdown.querySelector('.cac-dropdown-selected');
    const options = dropdown.querySelectorAll('.cac-dropdown-list li');
    const filterType = dropdown.getAttribute('data-filter-type');

    if (selected) {
      selected.addEventListener('click', (e) => {
        e.stopPropagation();
        dropdowns.forEach(d => { if (d !== dropdown) d.classList.remove('open') });
        dropdown.classList.toggle('open');
      });
    }

    if (options) {
      options.forEach(option => {
        option.addEventListener('click', function (e) {
          e.stopPropagation();

          const value = this.getAttribute('data-value');
          const label = this.getAttribute('data-label');

          if (filterType === 'tag1') {
            // Checkbox logic
            this.classList.toggle('selected');

            const selectedOptions = Array.from(options).filter(o => o.classList.contains('selected'));

            if (selectedOptions.length === 0) {
              state.tag1 = [];
              setLabelText('tag1-label', defaultLabels.tag1);
            } else {
              state.tag1 = selectedOptions.map(o => o.getAttribute('data-value'));
              if (selectedOptions.length === 1) {
                setLabelText('tag1-label', selectedOptions[0].getAttribute('data-label'));
              } else {
                setLabelText('tag1-label', selectedOptions.length + ' selezionati');
              }
            }
          } else {
            // Radio logic
            options.forEach(o => o.classList.remove('selected'));
            this.classList.add('selected');

            if (filterType === 'sort') {
              state.sort = value;
              setLabelText('sort-label', label);
            } else if (filterType === 'tag2') {
              state.tag2 = value;
              setLabelText('tag2-label', label);
            }
            dropdown.classList.remove('open');
          }

          applyFilters();
        });
      });
    }
  });

  document.addEventListener('click', () => {
    dropdowns.forEach(d => d.classList.remove('open'));
  });

  // 3. Clear Filters
  if (clearBtn) {
    clearBtn.addEventListener('click', doFullClear);
  }

  // --- Mobile Filter Popup and Sync Logic ---
  const mobileTrigger = document.getElementById('cac-mobile-filter-trigger');
  const mobileClose = document.getElementById('cac-mobile-filter-close');
  const mobilePopup = document.getElementById('cac-mobile-filter-popup');
  const mobileClearBtn = document.getElementById('cac-mobile-clear-btn');
  const mobileOptions = document.querySelectorAll('.cac-mobile-options li');

  if (mobileTrigger && mobilePopup) {
    mobileTrigger.addEventListener('click', function () {
      mobilePopup.classList.add('open');
      document.body.style.overflow = 'hidden';
    });
  }

  if (mobileClose && mobilePopup) {
    mobileClose.addEventListener('click', function () {
      mobilePopup.classList.remove('open');
      document.body.style.overflow = '';
    });
  }

  if (mobilePopup) {
    mobilePopup.addEventListener('click', function (e) {
      if (e.target === mobilePopup) {
        mobilePopup.classList.remove('open');
        document.body.style.overflow = '';
      }
    });
  }

  if (mobileClearBtn) {
    mobileClearBtn.addEventListener('click', function () {
      doFullClear();
      mobilePopup.classList.remove('open');
      document.body.style.overflow = '';
    });
  }

  // Handle Mobile Options Selection and sync back to desktop state
  mobileOptions.forEach(option => {
    option.addEventListener('click', function (e) {
      e.stopPropagation();
      const parentList = this.closest('.cac-mobile-options');
      if (!parentList) return;
      const filterType = parentList.getAttribute('data-filter-type');
      const value = this.getAttribute('data-value');
      const label = this.getAttribute('data-label');

      // Find matching desktop dropdown and its options
      const desktopDropdown = document.querySelector(`.cac-dropdown[data-filter-type="${filterType}"]`);
      const desktopOptions = desktopDropdown ? desktopDropdown.querySelectorAll('.cac-dropdown-list li') : [];

      if (filterType === 'tag1') {
        // Checkbox logic
        this.classList.toggle('selected');

        // Sync with desktop checkbox
        if (desktopOptions.length > 0) {
          desktopOptions.forEach(opt => {
            if (opt.getAttribute('data-value') === value) {
              opt.classList.toggle('selected');
            }
          });
          const selectedDesktopOptions = Array.from(desktopOptions).filter(o => o.classList.contains('selected'));
          if (selectedDesktopOptions.length === 0) {
            state.tag1 = [];
            document.getElementById('tag1-label').innerText = defaultLabels.tag1;
          } else {
            state.tag1 = selectedDesktopOptions.map(o => o.getAttribute('data-value'));
            if (selectedDesktopOptions.length === 1) {
              document.getElementById('tag1-label').innerText = selectedDesktopOptions[0].getAttribute('data-label');
            } else {
              document.getElementById('tag1-label').innerText = selectedDesktopOptions.length + ' selezionati';
            }
          }
        }
      } else {
        // Radio logic
        const siblings = parentList.querySelectorAll('li');
        siblings.forEach(s => s.classList.remove('selected'));
        this.classList.add('selected');

        // Sync with desktop radio
        if (desktopOptions.length > 0) {
          desktopOptions.forEach(opt => {
            if (opt.getAttribute('data-value') === value) {
              opt.classList.add('selected');
            } else {
              opt.classList.remove('selected');
            }
          });

          if (filterType === 'sort') {
            state.sort = value;
            document.getElementById('sort-label').innerText = label;
          } else if (filterType === 'tag2') {
            state.tag2 = value;
            document.getElementById('tag2-label').innerText = label;
          }
        }
      }

      applyFilters();
    });
  });

  // Sync mobile visual selections from the desktop state (so clear filters / type tab clicks updates mobile)
  function syncMobileState() {
    mobileOptions.forEach(item => {
      const parent = item.closest('.cac-mobile-options');
      if (!parent) return;
      const filterType = parent.getAttribute('data-filter-type');
      const val = item.getAttribute('data-value');

      if (filterType === 'tag1') {
        if (state.tag1.includes(val)) {
          item.classList.add('selected');
        } else {
          item.classList.remove('selected');
        }
      } else if (filterType === 'sort') {
        if (state.sort === val) {
          item.classList.add('selected');
        } else {
          item.classList.remove('selected');
        }
      } else if (filterType === 'tag2') {
        if (state.tag2 === val) {
          item.classList.add('selected');
        } else {
          item.classList.remove('selected');
        }
      }
    });
  }

  // Mobile Layout Toggle (List/Grid view)
  // List-view is the CSS default on mobile; toggle switches to grid-view
  const layoutBtn = document.querySelector('.cac-mobile-layout-btn');
  if (layoutBtn && grid) {
    layoutBtn.addEventListener('click', function () {
      grid.classList.toggle('grid-view');
      layoutBtn.classList.toggle('active');
    });
  }

  // Cancel bar (old block-based, keep for backward compat)
  const cancelBar = document.getElementById('cac-cancel-bar');
  const cancelActionBtn = document.getElementById('cac-cancel-action-btn');

  // New: Filter Reveal Section â€” target by data-cac-filter-reveal attribute
  const filterRevealSection = document.querySelector('[data-cac-filter-reveal="true"]')
    ? document.querySelector('[data-cac-filter-reveal="true"]').closest('[id^="shopify-section-"]')
    : null;

  // Read mode: true = show only when filter active (default), false = always visible
  const cacSection = document.querySelector('.cac-full-section');
  const cfrConditional = cacSection ? cacSection.dataset.cfrConditional !== 'false' : true;

  function getCfrBtn() {
    return filterRevealSection ? filterRevealSection.querySelector('#cfr-cancel-btn') : null;
  }

  // Set initial state of filter reveal section
  if (filterRevealSection) {
    if (cfrConditional) {
      // Conditional mode: hidden by default, shown when filter active
      filterRevealSection.style.display = 'none';
    } else {
      // Always visible mode: show section but disable button
      filterRevealSection.style.display = '';
      const cfrBtn = getCfrBtn();
      if (cfrBtn) {
        cfrBtn.disabled = true;
        cfrBtn.classList.add('cfr-btn-inactive');
      }
    }
  }

  // Listen for cancel event from the reveal section's button
  document.addEventListener('cac:clear-filters', doFullClear);
  function doFullClear() {
    state = { type: null, customFilter: null, sort: 'relevance', tag1: [], tag2: 'tutte le fasi' };
    typeTabs.forEach(t => t.classList.remove('active-type'));
    if (typeFilters) typeFilters.classList.remove('has-active-tab');
    updateURLFilterParam(null);
    dropdowns.forEach(d => {
      const filterType = d.getAttribute('data-filter-type');
      const options = d.querySelectorAll('li');
      options.forEach(o => o.classList.remove('selected'));
      if (filterType === 'tag1') {
        setLabelText('tag1-label', defaultLabels.tag1);
      } else {
        if (options[0]) options[0].classList.add('selected');
        if (filterType === 'sort') setLabelText('sort-label', 'rilevanza');
        if (filterType === 'tag2') setLabelText('tag2-label', defaultLabels.tag2);
      }
    });
    applyFilters();
  }

  if (cancelActionBtn) {
    cancelActionBtn.addEventListener('click', doFullClear);
  }

  // 4. Main Filter Function
  function applyFilters() {
    if (!grid) return;
    let visibleCount = 0;
    const products = Array.from(grid.querySelectorAll('.cac-product-card'));

    products.forEach(p => {
      let show = true;
      const pType = p.getAttribute('data-type') || '';
      const pTagsRaw = p.getAttribute('data-tags');
      const pTags = pTagsRaw ? pTagsRaw.split(',').map(t => t.trim()) : [];

      // Tab filter: custom mode vs dynamic type mode
      if (isCustomFilterMode) {
        if (state.customFilter) {
          const pCustomFilters = (p.getAttribute('data-custom-filters') || '').split(',').map(s => s.trim());
          if (!pCustomFilters.includes(state.customFilter)) show = false;
        }
      } else {
        if (state.type && pType !== state.type) show = false;
      }

      if (state.tag1 && state.tag1.length > 0) {
        const hasTag = state.tag1.some(tag => pTags.includes(tag));
        if (!hasTag) show = false;
      }

      if (state.tag2 && state.tag2 !== 'all' && state.tag2 !== 'tutte le fasi' && !pTags.includes(state.tag2)) show = false;

      if (show) {
        p.style.setProperty('display', 'flex', 'important');
        visibleCount++;
      } else {
        p.style.setProperty('display', 'none', 'important');
      }
    });

    if (countSpan) {
      countSpan.innerText = visibleCount;
    }

    let visibleProducts = products.filter(p => p.style.display !== 'none');

    if (state.sort === 'price-ascending') {
      visibleProducts.sort((a, b) => parseFloat(a.dataset.price || 0) - parseFloat(b.dataset.price || 0));
    } else if (state.sort === 'price-descending') {
      visibleProducts.sort((a, b) => parseFloat(b.dataset.price || 0) - parseFloat(a.dataset.price || 0));
    } else {
      visibleProducts.sort((a, b) => parseInt(a.dataset.index || 0) - parseInt(b.dataset.index || 0));
    }

    visibleProducts.forEach(p => grid.appendChild(p));

    // Update active state and show/hide reveal section + cancel bar
    const isActive = state.type !== null || state.customFilter !== null || (state.tag1 && state.tag1.length > 0) || (state.tag2 !== 'all' && state.tag2 !== 'tutte le fasi') || state.sort !== 'relevance';
    
    if (mobileClearBtn) {
      if (isActive) {
        mobileClearBtn.classList.add('is-active');
      } else {
        mobileClearBtn.classList.remove('is-active');
      }
    }

    if (clearBtn) {
      if (isActive) {
        clearBtn.classList.add('is-active');
        if (cancelBar) cancelBar.style.display = 'flex';
        if (filterRevealSection) {
          filterRevealSection.style.display = '';
          if (!cfrConditional) {
            const cfrBtn = getCfrBtn();
            if (cfrBtn) {
              cfrBtn.disabled = false;
              cfrBtn.classList.remove('cfr-btn-inactive');
            }
          }
        }
      } else {
        clearBtn.classList.remove('is-active');
        if (cancelBar) cancelBar.style.display = 'none';
        if (filterRevealSection) {
          if (cfrConditional) {
            // Conditional mode: hide section
            filterRevealSection.style.display = 'none';
          } else {
            // Always visible mode: keep visible but disable button
            filterRevealSection.style.display = '';
            const cfrBtn = getCfrBtn();
            if (cfrBtn) {
              cfrBtn.disabled = true;
              cfrBtn.classList.add('cfr-btn-inactive');
            }
          }
        }
      }
    }
    if (typeof syncMobileState === 'function') {
      syncMobileState();
    }
  }

  // 5. Real-time Cart Add
  document.addEventListener('click', function (e) {
    const btn = e.target.closest('.cac-add-cart');
    if (btn) {
      e.preventDefault();
      const variantId = btn.getAttribute('data-variant-id');
      if (!variantId) return;

      btn.classList.add('loading');

      const isAdded = btn.classList.contains('clicked-state');

      if (isAdded) {
        let formData = {
          'id': variantId,
          'quantity': 0
        };

        fetch(window.Shopify.routes.root + 'cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(formData)
        })
          .then(response => response.json())
          .then(cart => {
            btn.classList.remove('loading');
            btn.classList.remove('clicked-state');
            if (typeof updateHeaderCartCount === 'function') {
              updateHeaderCartCount();
            }
            document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
            document.dispatchEvent(new CustomEvent('cart:build'));
            window.dispatchEvent(new Event('cart:refresh'));
          })
          .catch(error => {
            console.error('Error removing from cart:', error);
            btn.classList.remove('loading');
          });
      } else {
        let formData = {
          'items': [{
            'id': parseInt(variantId),
            'quantity': 1
          }]
        };

        fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(formData)
        })
          .then(response => response.json())
          .then(cart => {
            btn.classList.remove('loading');
            btn.classList.add('clicked-state');
            if (typeof updateHeaderCartCount === 'function') {
              updateHeaderCartCount();
            }
            document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
            document.documentElement.dispatchEvent(new CustomEvent('cart:add', { bubbles: true }));
            document.dispatchEvent(new CustomEvent('cart:build'));
            window.dispatchEvent(new Event('cart:refresh'));
          })
          .catch(error => {
            console.error('Error adding to cart:', error);
            btn.classList.remove('loading');
          });
      }
    }
  });

  // 6. Auto-select filter from URL parameter (e.g., ?filter=kit-1-giorno)
  const urlParams = new URLSearchParams(window.location.search);
  const filterParam = urlParams.get('filter');
  if (filterParam) {
    const targetTab = document.querySelector(`.cac-type-tab[data-handle="${filterParam}"]`);
    if (targetTab) {
      targetTab.click();
      
      // Scroll to tabs slightly after click
      setTimeout(() => {
        const tabRow = document.querySelector('.cac-tabs-row');
        if (tabRow) {
          const headerOffset = 100; // adjust if sticky header exists
          const elementPosition = tabRow.getBoundingClientRect().top;
          const offsetPosition = elementPosition + window.pageYOffset - headerOffset;
          window.scrollTo({
             top: offsetPosition,
             behavior: "smooth"
          });
        }
      }, 300);
    }
  }
});

